import React from 'react'
import Button from '@components/V3/Button'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useReorder from '@page-components/TrackV2/hooks/useReorder.main'
import useStatus from '@page-components/TrackV2/hooks/useStatus'
import {useApolloQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {useTranslation} from 'next-i18next'

function CancelledInfoInner() {
  const {order} = useOrder()
  const repeatOrder = useReorder()
  const {t} = useTranslation('tracking', {keyPrefix: 'cancelledInfo'})
  const {order: cancelInfo} = useApolloQuery({
    query: gql`
      query TrackingV2CancellationReason($orderId: ID!) {
        order(orderId: $orderId) {
          _id
          cancellationInfo {
            reasonMessage
          }
        }
      }
    `,
    variables: {
      orderId: order._id
    },
    fetchPolicy: 'cache-first'
  })

  return (
    <div className="flex flex-col gap-1 text-sm mt-4">
      <div className="flex">
        <div className="flex-1 min-w-[200px] font-semibold">{t('email')}</div>
        <div className="text-right">{order.email}</div>
      </div>
      <div className="flex">
        <div className="flex-1 min-w-[200px] font-semibold">{t('orderNumber')}</div>
        <div className="text-right">{order.fullCode}</div>
      </div>
      {cancelInfo?.cancellationInfo?.reasonMessage ? (
        <div className="flex">
          <div className="flex-1 min-w-[200px] font-semibold">{t('reason')}</div>
          <div className="text-right">{cancelInfo.cancellationInfo.reasonMessage}</div>
        </div>
      ) : null}
      <Button full primary onClick={repeatOrder} className="mt-8">
        {t('tryAgain')}
      </Button>
    </div>
  )
}

export default function CancelledInfo() {
  const status = useStatus()
  if (status !== 'cancelled') return null

  return <CancelledInfoInner />
}
